function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function formatSaleDate(ms) {
  var n = Number(ms);
  if (!n) {
    return '—';
  }
  var date = new Date(n);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString();
}
function formatSaleAmount(app, nolan) {
  try {
    var _app$wallet;
    var amount = BigInt(nolan !== null && nolan !== void 0 ? nolan : 0);
    if (amount > 0n && app !== null && app !== void 0 && (_app$wallet = app.wallet) !== null && _app$wallet !== void 0 && _app$wallet.convertNolanToSaito) {
      return "".concat(app.wallet.convertNolanToSaito(amount), " SAITO");
    }
    if (amount > 0n) {
      return String(amount);
    }
  } catch (err) {
    // fall through
  }
  return '';
}
function shortKey() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!key) {
    return '';
  }
  if (key.length <= 18) {
    return key;
  }
  return "".concat(key.slice(0, 8), "\u2026").concat(key.slice(-6));
}
module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$listings = _ref.listings,
    listings = _ref$listings === void 0 ? [] : _ref$listings,
    _ref$caption = _ref.caption,
    caption = _ref$caption === void 0 ? 'Sales' : _ref$caption;
  var rows = (listings || []).map(function (summary) {
    var _summary$returnTitle, _summary$quantity_sol;
    var app = summary.app;
    var signature = escapeHtml(summary.listing_signature || '');
    var title = escapeHtml(((_summary$returnTitle = summary.returnTitle) === null || _summary$returnTitle === void 0 ? void 0 : _summary$returnTitle.call(summary)) || summary.title || 'Untitled Item');
    var quantity_sold = Math.max(0, Number((_summary$quantity_sol = summary.quantity_sold) !== null && _summary$quantity_sol !== void 0 ? _summary$quantity_sol : 0) || 0);
    var total = '';
    try {
      var _summary$price;
      total = formatSaleAmount(app, BigInt((_summary$price = summary.price) !== null && _summary$price !== void 0 ? _summary$price : 0) * BigInt(quantity_sold));
    } catch (err) {
      total = '';
    }
    var sold_at = escapeHtml(formatSaleDate(summary.sold_at));
    var buyer = String(summary.buyer || '').trim();
    var seller_note = String(summary.seller_note || '').trim();
    var buyer_html = '—';
    if (buyer) {
      var note_html = seller_note ? "<div class=\"sales-seller-note\">".concat(escapeHtml(seller_note), "</div>") : '';
      buyer_html = "\n            <div class=\"sales-buyer\">\n              <div class=\"sales-buyer-row\">\n                <span class=\"sales-buyer-address\" title=\"".concat(escapeHtml(buyer), "\">").concat(escapeHtml(shortKey(buyer)), "</span>\n                <button type=\"button\" class=\"saito-icon-button sales-buyer-copy\" data-action=\"copy-buyer\" data-buyer=\"").concat(escapeHtml(buyer), "\" title=\"Copy buyer address\" aria-label=\"Copy buyer address\">\n                  <i class=\"fas fa-copy\" aria-hidden=\"true\"></i>\n                </button>\n              </div>\n              ").concat(note_html, "\n            </div>");
    } else if (seller_note) {
      buyer_html = "<div class=\"sales-seller-note\">".concat(escapeHtml(seller_note), "</div>");
    }
    return "\n          <tr data-signature=\"".concat(signature, "\">\n            <td class=\"sales-title\">").concat(title, "</td>\n            <td>").concat(quantity_sold || '—', "</td>\n            <td>").concat(escapeHtml(total) || '—', "</td>\n            <td class=\"sales-buyer-cell\">").concat(buyer_html, "</td>\n            <td>").concat(sold_at, "</td>\n          </tr>");
  }).join('');
  var captionHtml = caption ? "<caption>".concat(escapeHtml(caption), "</caption>") : '';
  return "\n    <div class=\"listings-table-wrap\">\n      <table class=\"listings-table sales-table\">\n        ".concat(captionHtml, "\n        <thead>\n          <tr>\n            <th scope=\"col\">Title</th>\n            <th scope=\"col\">Qty</th>\n            <th scope=\"col\">Total</th>\n            <th scope=\"col\">Buyer</th>\n            <th scope=\"col\">Date</th>\n          </tr>\n        </thead>\n        <tbody>").concat(rows, "\n        </tbody>\n      </table>\n    </div>\n  ");
};